import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { Anchor } from "@phosphor-icons/react";
import ChatWidget from "@/components/ChatWidget";
import Logo from "@/components/Logo";

export default function MarketingLayout() {
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen flex flex-col bg-[#FAFAFA]">
      <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/70 border-b border-black/5">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Logo testId="marketing-logo" />
          <nav className="flex items-center gap-6 text-sm">
            <Link to="/network" data-testid="nav-network-link" className={`hover:text-ember transition-colors ${pathname === "/network" ? "text-ember" : "text-navy/80"}`}>Network</Link>
            <Link to="/meetings" data-testid="nav-meetings-link" className={`hover:text-ember transition-colors ${pathname === "/meetings" ? "text-ember" : "text-navy/80"}`}>Events</Link>
            <Link to="/apply" data-testid="nav-apply-link" className="hidden sm:inline btn-primary !py-2 !px-4">Apply for membership</Link>
            <Link to="/portal/login" data-testid="nav-member-login-link" className="text-xs uppercase tracking-widest text-navy/50 hover:text-navy">Members</Link>
            <Link to="/admin/login" data-testid="nav-admin-link" className="text-xs uppercase tracking-widest text-navy/30 hover:text-navy hidden sm:inline">Admin</Link>
          </nav>
        </div>
      </header>
      <div className="flex-1">
        <Outlet />
      </div>
      <footer className="border-t border-black/10 bg-white mt-24" data-testid="marketing-footer">
        <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-12 gap-10 text-sm">
          <div className="md:col-span-5">
            <Logo asLink={false} size="md" testId="footer-logo" />
            <p className="mt-4 text-navy/70 max-w-sm">Curated global freight forwarding network. Territory-protected cooperation built on trust.</p>
            <p className="mt-4 text-xs uppercase tracking-widest text-navy/50">Operated by EP air&amp;sea d.o.o. · Koper · Slovenia</p>
          </div>
          <div className="md:col-span-3">
            <div className="overline mb-3">Network</div>
            <ul className="space-y-2 text-navy/80">
              <li><Link to="/network" className="hover:text-ember">Coverage & territory</Link></li>
              <li><Link to="/meetings" className="hover:text-ember">Events</Link></li>
              <li><Link to="/apply" className="hover:text-ember">Apply</Link></li>
              <li><Link to="/vendors/apply" className="hover:text-ember">List as a vendor</Link></li>
              <li><Link to="/portal/login" className="hover:text-ember">Member portal</Link></li>
              <li><Link to="/admin/login" className="hover:text-ember text-navy/50">Operator</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <div className="overline mb-3">Imprint</div>
            <address className="not-italic text-navy/80 text-[13px] leading-relaxed space-y-1" data-testid="footer-imprint">
              <div className="font-semibold text-navy">EP air&amp;sea, logistika, d.o.o.</div>
              <div>Ankaranska cesta 5A, 6000 Koper — Capodistria, Slovenia</div>
              <div>VAT ID: SI62310704 · Reg. no. 6545297</div>
              <div>Registered at Okrožno sodišče Koper · Share capital €7,500</div>
              <div className="pt-1">
                <a href="mailto:rok@epas.one" className="text-navy hover:text-ember">rok@epas.one</a>
                <span className="text-navy/30 mx-2">·</span>
                <a href="https://epasone.myeuropacific.com" target="_blank" rel="noreferrer" className="text-navy hover:text-ember">epasone.myeuropacific.com</a>
              </div>
            </address>
          </div>
        </div>
        <div className="border-t border-black/5 py-4 text-center text-xs text-navy/50">
          © {new Date().getFullYear()} EP air&amp;sea d.o.o. · EPAS Global Logistics Network. All rights reserved.
        </div>
      </footer>
      <ChatWidget />
    </div>
  );
}
